import { render, staticRenderFns } from "./BelongingHome.vue?vue&type=template&id=559cb8f9&"
import script from "./BelongingHome.vue?vue&type=script&lang=js&"
export * from "./BelongingHome.vue?vue&type=script&lang=js&"
import style0 from "./BelongingHome.vue?vue&type=style&index=0&id=559cb8f9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports